'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);

const modalDialogFooter = "_modal-dialog-footer_ynl6j_1";
const styles = {
	modalDialogFooter: modalDialogFooter
};

const ModalDialogFooter = ({ children, className, style }) => {
  const contextValue = React.useMemo(() => ({ size: "medium" }), []);
  return jsxRuntime.jsx("footer", { className: clsx__default.default(styles.modalDialogFooter, className), "data-zds": true, style, children: jsxRuntime.jsx(designSystem.ButtonContext.Provider, { value: contextValue, children }) });
};

exports.ModalDialogFooter = ModalDialogFooter;
//# sourceMappingURL=Footer.cjs.js.map
